module.exports = __webpack_public_path__ + "static/media/3.af59c02d.png";